import YouTubePlayer from 'youtube-player'

// TODO: fix youtube player import
export default {
  install(app) {
    app.config.globalProperties.$YouTubePlayer = YouTubePlayer;
  }
};
